import React, { useEffect } from 'react'
import { leagueAttendanceStore } from 'state/league/leagueAttendance'
import { leagueEventStore } from 'state/league/leagueEvent'
import { useGetLeagueParticipantHistory } from 'api/league/LeagueAttendance/leagueAttendance'
import Spinner from 'components/Spinner'
import moment from 'moment'
import { convertToUtc } from 'helper/utility'

const LeagueHistoryTab: React.FC = () => {
  const { selectedAttendee, selectedDate } = leagueAttendanceStore(store => ({
    selectedAttendee: store.selectedAttendee,
    selectedDate: store.selectedDate,
  }))

  const { leagueData } = leagueEventStore(store => ({ leagueData: store.leagueData }))

  const params = {
    leagueId: leagueData?._id || '',
    date: convertToUtc(selectedDate),
  }

  const {
    data: history,
    isLoading,
    isFetching,
    refetch,
  } = useGetLeagueParticipantHistory(selectedAttendee?._id || '', params)

  useEffect(() => {
    if (selectedAttendee?._id && leagueData?._id) {
      refetch()
    }
  }, [selectedAttendee?._id, params.date])

  if (isLoading || isFetching) {
    return (
      <div className="flex justify-center align-center py-40px w-full">
        <Spinner />
      </div>
    )
  }

  return (
    <div className="flex justify-between gap-100px mt-20px">
      <div className="flex-1 overflow-auto">
        <h3 className="text-14 w-600">
          {moment(selectedDate).format('DD MMMM YYYY')}
        </h3>
        <div>
          {Array.isArray(history) && history.length ? (
            history.map((record: any) => (
              <div className="border-btm pb-20px" key={record._id}>
                {(record.checkInStatus === 'checked-in' ||
                  record.checkInStatus === 'droped-in') &&
                record.checkedInAt ? (
                  <div className="mt-20px relative">
                    <h4 className="text-12 w-600 text-prim">Checked-in</h4>
                    <div className="flex gap-20px align-center justify-between mt-10px">
                      <p className="text-14 w-500">
                        {moment(record.checkedInAt).local().format('hh:mm A')}
                      </p>
                      {record.checkInOrganizer && (
                        <div className="text-right">
                          <p className="text-12">Organizer check-in</p>
                          <p className="text-14 w-500">{`${record.checkInOrganizer.firstName} ${record.checkInOrganizer.lastName}`}</p>
                        </div>
                      )}
                      {record.checkInAdmin && (
                        <div className="text-right">
                          <p className="text-12">Admin check-in</p>
                          <p className="text-14 w-500">{`${record.checkInAdmin.firstName} ${record.checkInAdmin.lastName}`}</p>
                        </div>
                      )}
                    </div>
                    {record.checkInNotes && (
                      <p className="text-12 mt-8px" style={{ color: '#908F98' }}>
                        Note: {record.checkInNotes}
                      </p>
                    )}
                  </div>
                ) : null}

                {record.checkedOutAt ? (
                  <div className="mt-20px relative">
                    <h4 className="text-12 w-600 danger-txt">Checked-out</h4>
                    <div className="flex gap-20px align-center justify-between mt-10px">
                      <p className="text-14 w-500">
                        {moment(record.checkedOutAt).local().format('hh:mm A')}
                      </p>
                      {record.checkOutOrganizer && (
                        <div className="text-right">
                          <p className="text-12">Organizer check-out</p>
                          <p className="text-14 w-500">{`${record.checkOutOrganizer.firstName} ${record.checkOutOrganizer.lastName}`}</p>
                        </div>
                      )}
                      {record.checkOutAdmin && (
                        <div className="text-right">
                          <p className="text-12">Admin check-out</p>
                          <p className="text-14 w-500">{`${record.checkOutAdmin.firstName} ${record.checkOutAdmin.lastName}`}</p>
                        </div>
                      )}
                    </div>
                    {record.signatureImageId && (
                      <p className="text-12 mt-8px" style={{ color: '#2BA7CA' }}>
                        ✓ Signature on file
                      </p>
                    )}
                  </div>
                ) : null}
              </div>
            ))
          ) : (
            <p>No history found</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default LeagueHistoryTab
